let module = {};

/**
 * Container Initialization
 */
module.init = function () {

    let mp4Player = document.querySelectorAll('.js-custom-video-player');

    //For Each Video player, setup our play/pause events
    mp4Player.forEach((player) => {
        let video = player.querySelector('video');
        let playButton = player.querySelector('.js-video-play');
        let pauseButton = player.querySelector('.js-video-pause');

        let togglePlay = () => {
            playButton.classList.toggle('visually-hidden');
            pauseButton.classList.toggle('visually-hidden');
        }

        playButton.addEventListener('click', () => {
            togglePlay();
            video.play();
        });

        pauseButton.addEventListener('click', () => {
            togglePlay();
            video.pause();
        });
    });
};

document.addEventListener("DOMContentLoaded", () => {
    module.init();
});
